import { GridController, gridTpl } from '../../../../common/grid/grid.controller';
import { IDS } from '../master-doc-list-action-id.constants';
import * as Actions from '../master-doc-list.actions';

class MasterDocListRequirementsGridController extends GridController {
    constructor($ngRedux, $state, NavigationService, AuthService, $filter, $mdDialog, $scope) {
        super($ngRedux, $state, NavigationService, $filter, $mdDialog);
        this.$scope = $scope;
        this.AuthService = AuthService;
    }

    $onInit() {
        this.module = 'accreditation';
        this.identifier = IDS.masterDocList;
        this.statePath = IDS.masterDocListRequirementsGrid;
        this.filterOpen = true;
        this.filterExpandButtonVisible = false;
        this.exportComponent = false;
        this.confirmDialogOnRemove = true;
        this.autoload = false;

        this.isAdmin = this.AuthService.getUser().type === 'Administrator';

        this.columnsDefault = [
            {title: '#',                                                mapper: null},
            {title: 'Requirement',                                      mapper: 'name'},
            {title: this.$filter('translate')(`COMMON.DATE.DUE_DATE`),  mapper: 'due_date'},
            {title: this.$filter('translate')(`COMMON.FIELD.STATUS`),   mapper: 'status'},
        ];
        this.columns = this.columnsDefault.concat();

        this.unsubscribe = this.$ngRedux.connect(this.mapState().bind(this), Actions)(this);

        this.dataAction = this.fetchRcoDocumentRequirementStatusesGrid;

        this.buttons = [
          {
            class: "btnGridAction",
            label: "Details",
            callback: this.onSelect,
          },
        ];
        this.init();

        this.buttonsDefault = this.buttons.concat();
    }

    $onDestroy() {
        this.destroy();
    }
}

MasterDocListRequirementsGridController.$inject = ['$ngRedux', '$state', 'NavigationService', 'AuthService', '$filter', '$mdDialog', '$scope'];

export const masterDocListRequirementsGrid = {
    bindings: {
        title: '@',
        onSelect: '&',
    },
    controller: MasterDocListRequirementsGridController,
    ...gridTpl
}
